<template>
  <div class="online_doc_item explain">
    <p class="online_doc_item_top">
      <i class="iconfont iconapiwendang_fanhuishili"></i>
      <span>{{ $t(name) }}</span>
    </p>
    <json-viewer v-if="code" class="pre_api" :expanded="true" :expand-depth="10" :value="code"></json-viewer>
    <template v-else-if="codes && codes.length > 0">
      <div v-for="(item, index) in codes" :key="index">
        <h3 class="online_doc_h3" v-show="item.title">{{ $t(item.title) }}</h3>
        <json-viewer class="pre_api" :expanded="true" :expand-depth="10" :value="item.value"></json-viewer>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['name', 'code', 'codes'],
}
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
.online_doc_h3 {
  color: #666666;
  font-size: 16px;
  line-height: 44px;
}
</style>